import React, { Component } from 'react'
import styled from 'styled-components'
import { Field, reduxForm } from 'redux-form'
import Input from '../UI/Form/Input'
import TextArea from '../UI/Form/TextArea'
import Button from '../UI/Button'
import { required, email } from '../../utils/validators'
import { connect } from 'react-redux'
import { contactMessage } from '../../actions/contact'

const Wrapper = styled.form`
  width: 100%;
`

const FormGroup = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: ${props => props.margin};
`

let Form = class Form extends Component {
  handleFormSubmit (values) {
    console.log(values)
    this.props.contactMessage(values)
  }

  render () {
    const { handleSubmit } = this.props
    return (
      <Wrapper onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
        <FormGroup margin='20px 0'>
          <Field
            name='name'
            required
            component={Input}
            type='text'
            width='100%'
            label='Nome'
            validate={[required]}
          />
        </FormGroup>
        <FormGroup margin='20px 0'>
          <Field
            name='email'
            required
            component={Input}
            type='email'
            width='100%'
            label='E-mail'
            validate={[required, email]}
          />
        </FormGroup>
        <FormGroup margin='20px 0 20px 0'>
          <Field
            name='message'
            required
            component={TextArea}
            width='100%'
            label='Messaggio'
            validate={[required]}
          />
        </FormGroup>
        <Button secondary size='small' type='submit'>INVIA MESSAGGIO</Button>
        <p style={{ color: 'green' }}>{this.props.success && 'Messaggio inviato con successo'}</p>
      </Wrapper>
    )
  }
}

function mapStateToProps (state) {
  return {
    success: state.contact.success,
    error: state.contact.error
  }
}

Form = connect(mapStateToProps, { contactMessage })(Form)

Form = reduxForm({
  form: 'contactForm' // a unique identifier for this form
})(Form)

export default Form



// WEBPACK FOOTER //
// ./src/components/Forms/Contact.js